import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import tgai from '../TourGuideAi.module.scss';

const InputBar = ({
  value,
  onChange,
  onSubmit,
  onActivity,
  disabled,
}) => (
  <div className={cx(tgai.inputBar)} data-tgai-input data-testid="tgai-input-bar">
    <textarea
      rows={1}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
        onActivity();
      }}
      onFocus={onActivity}
      onClick={onActivity}
      disabled={disabled}
      onKeyDown={(e) => {
        onActivity();
        if (e.key === 'Enter' && !e.shiftKey && !disabled && value.trim()) {
          e.preventDefault();
          onSubmit();
        }
      }}
      data-testid="tgai-input"
    />
    <button
      type="button"
      onClick={onSubmit}
      className={cx(tgai.btn, tgai.primary)}
      disabled={disabled}
      data-testid="tgai-send"
    >
      Send
    </button>
  </div>
);

InputBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onActivity: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

InputBar.defaultProps = {
  disabled: false,
};

export default InputBar;
